import React, {useEffect, useState} from 'react';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';
import {getMyLinks, getPublicLinks} from 'util/api';
import DonationCard from './DonationCard';
import 'styles/donations/DonationList.css';
import UniversalOptionsList from 'components/universal/UniversalOptionsList';
import {useNavigate} from 'react-router-dom';
import UniversalTypeFilter from 'components/universal/UniversalTypeFilter';

const myDonation = 'MY';
const allDonation = 'ALL';

const DonationList = ({myDonations}) => {
    const [donations, setDonations] = useState([]);
    const [filteredDonations, setFilteredDonations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedFilter, setSelectedFilter] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const fetchLinks = myDonations ? getMyLinks : getPublicLinks;
        fetchLinks()
            .then((response) => {
                const donationLinks = response.map((link) => ({
                    id: link.id,
                    charityName: link.charityName,
                    link: link.link,
                    badgeId: link.badgeId,
                    createdOn: link.createdOn,
                    status: link.state,
                    rejectionReason: link.adminRejectionReason || null,
                }));

                setLoading(false);
                setDonations(donationLinks);
                setFilteredDonations(donationLinks);
            })
            .catch((error) => {
                console.error('Error fetching donation links:', error);
                setLoading(false);
            });
    }, [myDonations]);

    const onOptionClick = (option) => {
        if (option === 'MY') {
            navigate('/my-donations');
        } else {
            navigate('/public-donations');
        }
    };

    const handleFilterClick = (key) => {
        const updatedFilter = selectedFilter.includes(key)
            ? selectedFilter.filter((filterKey) => filterKey !== key)
            : [...selectedFilter, key];

        setSelectedFilter(updatedFilter);

        if (updatedFilter.length === 0) {
            setFilteredDonations(donations);
        } else {
            setFilteredDonations(
                donations.filter((donation) => updatedFilter.includes(donation.status.toUpperCase()))
            );
        }
    };

    const filterTypes = myDonations
        ? [['APPROVED', 'Approved'], ['REJECTED', 'Rejected'], ['PENDING', 'Pending'], ['CANCELLED', 'Cancelled']]
        : [['APPROVED', 'Approved'], ['REJECTED', 'Rejected']];

    return (
        <>
            <UniversalEmptyPageHeader image={'donations'} text={'Donation links'} desktopText={true}/>
            <div className="donation-list-container">
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '12px'}}>
                    <UniversalOptionsList
                        initialOption={myDonations ? myDonation : allDonation}
                        options={[myDonation, allDonation]}
                        onOptionClick={onOptionClick}
                    />
                    <UniversalTypeFilter
                        types={filterTypes}
                        highlightedKeys={selectedFilter}
                        itemClicked={handleFilterClick}
                    />
                </div>
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <ul className="donation-list">
                    {filteredDonations.map((donation) => (
                        <DonationCard key={donation.id} donation={donation}/>
                    ))}
                    </ul>
                )}
            </div>
        </>
    );
};

export default DonationList;